module.exports = __webpack_public_path__ + "static/media/ico-complete-chat.eb982d8e.svg";